<div class="top_living_header_wrapper">
    <div class="container ">
        <h1 class="top_living_header text-center" >Top Living Areas</h1>
    </div>
</div>
<div class="container-fluid">
    <div class="city_name">
        <h1 class="top_city mr-2 activeCity" id="blr" (click)="topCityAreas('blr')" >Bengaluru</h1>
        <h1 class="top_city ml-2 " id="pune" (click)="topCityAreas('pune')">Pune</h1>
    </div>
    <div class="container">
        <div style="margin-top: 20px; margin-bottom: 20px;">
            <div class="row city_areas" *ngIf="cityName == 'bengaluru'">
                <h1 class="area_name col-lg-2 col-md-2 col-sm-3 text-center" (click)="cityTopAreas(1, 'HSR Layout')"> HSR Layout </h1>
                <h1 class="area_name col-lg-2 col-md-2 col-sm-3 text-center" (click)="cityTopAreas(1, 'Bellandur')"> Bellandur </h1>
                <h1 class="area_name col-lg-2 col-md-2 col-sm-3 text-center" (click)="cityTopAreas(1, 'Whitefield')"> Whitefield</h1>
                <h1 class="area_name col-lg-2 col-md-2 col-sm-3 text-center" (click)="cityTopAreas(1, 'Kormangala')"> Kormangala </h1>
                <h1 class="area_name col-lg-2 col-md-2 col-sm-3 text-center" (click)="cityTopAreas(1, 'Electronic City')"> Electronic City </h1>
            </div>
            <div class="row city_areas" *ngIf="cityName == 'pune'"> 
                <h1 class="area_name col-lg-2 col-md-2 col-sm-3 text-center" (click)="cityTopAreas(1, 'Viman Nagar')"> Viman Nagar </h1> 
                <h1 class="area_name col-lg-2 col-md-2 col-sm-3 text-center" (click)="cityTopAreas(1, 'Kharadi')"> Kharadi</h1> 
                <h1 class="area_name col-lg-2 col-md-2 col-sm-3 text-center" (click)="cityTopAreas(1, 'Hadapsar')"> Hadapsar</h1> 
                <h1 class="area_name col-lg-2 col-md-2 col-sm-3 text-center" (click)="cityTopAreas(1, 'Hinjewadi')"> Hinjewadi</h1> 
                <h1 class="area_name col-lg-2 col-md-2 col-sm-3 text-center" (click)="cityTopAreas(1, 'Magarpatta')"> Magarpatta</h1> 
            </div> 
        </div>
    </div>
    
    <div class="container">
        <div class="row">
            <div class="col-md-8">
                <h1  style="font-weight: 500; "> Area Advantanges </h1>
            </div>
        </div>
    </div>
    <div class="container society_feat">
        <div class="row" style="margin-top: 30px;">
            <div class="col-md-4 text-center d-flex justify-content-center align-items-center" style="flex-direction: column">
                <div class="area_adv_icons_wrapper">
                    <fa-icon [icon]="faParking" class="fa-3x area_adv_icons" ></fa-icon>
                </div>
                <h3 style="font-weight: 500; margin-top: 10px">Parking</h3>
            </div>
            <div class="col-md-4 text-center d-flex justify-content-center align-items-center" style="flex-direction: column">
                <div class="area_adv_icons_wrapper">
                    <fa-icon [icon]="faDumbbell" class="fa-3x area_adv_icons" ></fa-icon>
                </div>
                <h3 style="font-weight: 500; margin-top: 10px" >Gyms</h3>
            </div>
            <div class="col-md-4 text-center d-flex justify-content-center align-items-center" style="flex-direction: column">
                <div class="area_adv_icons_wrapper">
                    <fa-icon [icon]="faHospital" class="fa-3x area_adv_icons" ></fa-icon>
                </div>
                <h3 style="font-weight: 500; margin-top: 10px" >Hospitals</h3>
            </div>
        </div>
        <div class="row" style="margin-top: 50px;">
            <div class="col-md-4 text-center d-flex justify-content-center align-items-center" style="flex-direction: column">
                <div class="area_adv_icons_wrapper">
                    <fa-icon [icon]="faBuilding" class="fa-3x area_adv_icons" ></fa-icon>
                </div>
                <h3 style="font-weight: 500; margin-top: 10px" >Resturants </h3>
            </div>
            <div class="col-md-4 text-center d-flex justify-content-center align-items-center" style="flex-direction: column">
                <div class="area_adv_icons_wrapper">
                    <fa-icon [icon]="faTableTennis" class="fa-3x area_adv_icons" ></fa-icon>
                </div>
                <h3 style="font-weight: 500; margin-top: 10px" >Playgrounds</h3>
            </div>
            <div class="col-md-4 text-center d-flex justify-content-center align-items-center" style="flex-direction: column">
                <div class="area_adv_icons_wrapper">
                    <fa-icon [icon]="faShoppingCart" class="fa-3x area_adv_icons" ></fa-icon>
                </div>
                <h3 style="font-weight: 500; margin-top: 10px" >Malls</h3>
            </div>
        </div>
    </div>
    <div class="container society_feat_sm">
        <div class="row" style="margin-top: 60px;">
            <div class="col-6 text-center d-flex justify-content-center align-items-center" style="flex-direction: column;">
                <div class="area_adv_icons_wrapper">
                    <fa-icon [icon]="faParking" class="fa-3x" ></fa-icon>
                </div>
                <h3 style="font-weight: 500; margin-top: 10px">Parkings </h3>
            </div>
            <div class="col-6 text-center d-flex justify-content-center align-items-center" style="flex-direction: column;">
                <div class="area_adv_icons_wrapper">
                    <fa-icon [icon]="faDumbbell" class="fa-3x" ></fa-icon>
                </div>
                <h3 style="font-weight: 500; margin-top: 10px">Gyms</h3>
            </div>
        </div>
        <div class="row">
            <div class="col-6 text-center d-flex justify-content-center align-items-center" style="flex-direction: column;">
                <div class="area_adv_icons_wrapper">
                    <fa-icon [icon]="faHospital" class="fa-3x" ></fa-icon>
                </div>
                <h3 style="font-weight: 500; margin-top: 10px">Hospitals</h3>
            </div>
            <div class="col-6 text-center d-flex justify-content-center align-items-center" style="flex-direction: column;">
                <div class="area_adv_icons_wrapper">
                    <fa-icon [icon]="faBuilding" class="fa-3x" ></fa-icon>
                </div>
                <h3 style="font-weight: 500; margin-top: 10px">Resturants</h3>
            </div>
        </div>
        <div class="row">
            <div class="col-6 text-center d-flex justify-content-center align-items-center" style="flex-direction: column;">
                <div class="area_adv_icons_wrapper">
                    <fa-icon [icon]="faTableTennis" class="fa-3x" ></fa-icon>
                </div>
                <h3 style="font-weight: 500; margin-top: 10px">Playgrounds</h3>
            </div>
            <div class="col-6 text-center d-flex justify-content-center align-items-center" style="flex-direction: column;">
                <div class="area_adv_icons_wrapper">
                    <fa-icon [icon]="faShoppingCart" class="fa-3x" ></fa-icon>
                </div>
                <h3 style="font-weight: 500; margin-top: 10px">Malls</h3>
            </div>
        </div>
    </div>
    <div class="container">
        <div *ngIf="loader == true" style="height: 200px; display: flex; justify-content: center; align-items: center;">
            <img src="assets/images/loading.gif" class="faLoader" width="50" height="50" />
        </div> 
        <div class="row" *ngIf="loader == false" style="margin-top: 20px;">
            <div class="col-md-4" *ngFor="let tlp of propList">
                <div class="prop_card" [routerLink]="['/property', tlp.id]" >
                    <div class="propertyList">
                        <div class="golden_prop_image">
                            <img *ngIf="tlp.image != null" src="{{ tlp.image.url }}" >
                            <img *ngIf="tlp.image == null" src="assets/images/coming-soon.png" class="p-4">
                        </div>
                        <div class="pl-3 pr-3">
                            <h1 class="gold_prop_name"> {{ tlp.name }} </h1>
                            <div class="d-flex justify-content-between" style="margin-top: 10px; margin-bottom: 20px;">
                                <div>
                                    <p style="font-size: 14px; margin-bottom: 0;">Starts From</p>
                                    <p class="prop_card_rent"> &#x20B9; {{ tlp.rent }} </p> 
                                </div>
                                <p class="prop_card_loc" style="text-align: right;"><fa-icon [icon]="faMapMarkerAlt" class="fa-lg" style="color:coral" ></fa-icon> {{ tlp.locality }}</p> 
                            </div>
                            <div class="d-flex justify-content-between align-items-center" style="margin-bottom: 10px;">
                                <p class="prop_card_gender"> All </p>
                                <p class="prop_card_status"> Available </p>
                            </div>
                            <hr style="margin-top: 0;">
                            <p class="prop_card_footer">{{ tlp.totalrooms }} BHK</p>
                            <p class="prop_card_footer">{{ tlp.sqftsuper }} sq.ft</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>


    
</div>